import React from 'react';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMSearchListTableRow from 'components/search/SMSearchListTableRow';
import SMFeatureStaffView from './SMFeatureStaffView';
import SMFeatureRoomView from './SMFeatureRoomView';
import moment from 'moment';
import SMSearchListSortView from 'components/search/SMSearchListSortView';
import SMCategorySearchFilterView from 'components/categories/SMCategorySearchFilterView';
import SMRestClient from 'lib/SMRestClient';
import sprintf from 'sprintf';
import OptimizedImage from 'components/shared/OptimizedImage';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';
import SMConst from 'lib/SMConst';
import SMSocialLineLink from 'components/social/SMSocialLineLink';

class SMFeatureView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      listItems: this.props.rooms,
      fbUrl: "",
      twitterUrl: "",
      pocketUrl: "",
      fbPageUrl: "",
      lineUrl: "",
      hasRank: this.props.feature.is_ranking,
      targetFavoriteRoom: {},
      latestUpdatedFavoriteList: {},
      isSMUFavoriteListSelectViewOpen: false,
    };
  }

  componentDidMount() {
    const feature = this.props.feature;
    const title = this.props.title;
    setTimeout(()=>{
      this.setState({
        fbUrl: sprintf("http://www.facebook.com/sharer/sharer.php?u=%s&t=%s",
          window.location.href,
          title
        ),
        twitterUrl: sprintf("https://twitter.com/intent/tweet?url=%s&text=%s",
          window.location.href,
          title
        ),
        pocketUrl: sprintf("javascript:window.open('http://getpocket.com/edit?url=%s&title=%s','_blank','width=400,height=460')",
          window.location.href,
          title
        ),
        lineUrl: window.location.href,
      });
    }, 100);
    SMTrackHelper.criteoList(this.props.currentUser ? this.props.currentUser.email : "", this.props.rooms);

    if (feature.uid == 'popular' &&
      (location.search.search("sort") == -1 || location.search.search("sort=popular") == 1)) {
      this.setState({hasRank: true});
    }
  }

  // SMSearchListTableRow delegate
  favoriteDidSelect(favorable, isFavorite, rowIndex) {
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    if (isFavorite) {
      // もしお気に入りに登録されている場合はリスト選択のモーダルを表示
      this.showFavoriteListSelectForm(favorable);
    } else {
      let room = favorable;
      let responseHandler = (data, error, xhr)=>{
        let listItems = this.state.listItems;
        if (error) {
          return;
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          listItems[rowIndex] = room;
          this.setState({
            listItems: listItems,
            latestUpdatedFavoriteList: data.favorite_list,
          });
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  sortDidChangeValue(value) {
    window.location.href = Routes.feature_path(this.props.feature.uid, {sort: value});
  }

  renderFeatureLinks() {
    if (this.props.feature == null || this.props.feature.feature_links == null) {
      return null;
    }
    return this.props.feature.feature_links.map(link => {
      return (
        <span>
          <a href={link.url} target="_blank">
            {link.name}
          </a>
          <br />
        </span>
      );
    });
  }

  render() {
    const feature = this.props.feature;
    const title = this.props.title;

    const updatedAt = moment(feature.updated_at).format("YYYY/MM/DD");
    let coverImageWidth = null;
    let coverImageHeight = null;
    if (SMAppHelper.isMobile()) {
      coverImageWidth = 600;
      coverImageHeight = 335;
    }

    const coverImageUrl = SMFormatHelper.imageURLWithTransform(feature.image, {width: coverImageWidth, height: coverImageHeight});

    return(
      <div className="site-main">
        <div className="mod-heroimg matome-list-detail__heroimg">
          <OptimizedImage
            src={coverImageUrl}
            alt={title}
            width={coverImageWidth}
            height={coverImageHeight}
            className="mod-heroimg__img matome-list-detail__heroimg-img"
          />
          <div className="mod-heroimg__bg matome-list-detail__heroimg-bg">
            <h1 className="mod-heroimg__title matome-list-detail__heroimg-title">{title}</h1>
          </div>
        </div>
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <div className="lpsearch-matome__text">
                  <p>{this.props.description}</p>
                  {this.renderFeatureLinks()}
                  {(()=>{
                    if (feature.event_types.length == 0) return null;
                    return (
                      <ul className="space-head__list">
                        <li className="space-head__list-tag"><i className="fa fa-tag mr5"></i>
                          <ul>
                            {feature.event_types.map((event_type)=>{
                              return (
                                <li key={event_type.name}><a href={`/event_types/${event_type.name}`}>{event_type.name_text}</a></li>
                              );
                            })}
                          </ul>
                        </li>
                      </ul>
                    );
                  })()}
                  <ul className="row lpsearch-matome__social">
                    <li className="col-xs-6 col-md-3 sm-mb10">
                      <a href={this.state.twitterUrl} target="_blank" className="social-link__twitter"><i className="fa fa-twitter"></i></a>
                    </li>
                    <li className="col-xs-6 col-md-3 sm-mb10">
                      <a href={this.state.fbUrl} target="_blank" className="social-link__facebook"><i className="fa fa-facebook-square"></i></a>
                    </li>
                    <li className="col-xs-6 col-md-3">
                      <a target="_blank" href={this.state.pocketUrl} className="social-link__pocket"><i className="fa fa-get-pocket"></i></a>
                    </li>
                    <li className="col-xs-6 col-md-3">
                      <SMSocialLineLink subject={title} body={this.state.lineUrl} gaLable='feature line btn' />
                    </li>
                  </ul>
                </div>
                <div className="search-list__sort">
                  <span className="service-select">
                    <SMSearchListSortView selectedValue={this.props.sort} delegate={this} />
                  </span>
                </div>
                <div className="search-list__head">
                  <div className="search-list__head-wrap">
                    <p className="search-list__head-title lpsearch-matome__head-update">最終更新日 {updatedAt}</p>
                    <span className="search-list__head-number lpsearch-matome__head-number">{this.props.totalCount}件</span>
                  </div>

                  <div className="units-list clear">
                    <ul ref="listContainer" className="row">
                      {this.state.listItems.map((room, index) => {
                        return (
                          <SMSearchListTableRow
                            key={room.id}
                            hasRank={(this.state.hasRank && this.props.currentPage == 1)}
                            room={room}
                            showBaloon={true}
                            noRoomImage={this.props.noRoomImage}
                            rowIndex={index}
                            canSlide={true}
                            delegate={this}
                            latestUpdatedFavoriteList={this.state.latestUpdatedFavoriteList} />
                        );
                      })}
                    </ul>
                  </div>
                  <SMSearchPagerView
                    delegate={this}
                    perPage={this.props.perPage}
                    totalCount={this.props.totalCount}
                    currentPage={this.props.currentPage}
                    links={SMRestClient.parseLinkString(this.props.linkString)} />
                </div>
              </div>
              <div className="col-sm-12 col-md-4">
                {(()=>{
                  if (feature.category_depth === SMConst.FeatureCategoryDepth.None || !this.props.regions) return null;
                  return (
                    <div className="site-sidebar">
                      <h2 className="site-sidebar__headline">エリアで絞り込む</h2>
                      <div className="lpsearch-sidebar__focus clearfix">
                        {this.props.regions.map((region)=>{
                          return(
                            <div key={region.id}>
                              <h3 className="lpsearch-sidebar__focus-category">{region.name_text}</h3>
                              <ul className="lpsearch-sidebar__focus-itemlist">
                              {region.large_areas.map((largeArea)=>{
                                return (
                                  <li key={largeArea.id} className="lpsearch-sidebar__focus-item"><a href={`/features/${feature.uid}/cities/${largeArea.name}`}>{largeArea.name_text}</a></li>
                                );
                              })}
                              </ul>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })()}
                {(()=>{
                  if (feature.category_depth === SMConst.FeatureCategoryDepth.None || !this.props.cities) return null;
                  const largeArea = this.props.largeArea;
                  return (
                    <div className="site-sidebar">
                      <h2 className="site-sidebar__headline">{largeArea.name_text}のエリアで絞り込む</h2>
                      <div className="lpsearch-sidebar__focus clearfix">
                        <h3 className="lpsearch-sidebar__focus-category">{largeArea.name_text}</h3>
                        <ul className="lpsearch-sidebar__focus-itemlist">
                        {this.props.cities.map((city)=>{
                          return (
                            <li key={city.id} className="lpsearch-sidebar__focus-item"><a href={`/features/${feature.uid}/cities/${city.name}--${largeArea.name}`}>{city.name_text}</a></li>
                          );
                        })}
                        </ul>
                      </div>
                    </div>
                  );
                })()}
                {(()=>{
                  if (feature.category_depth === SMConst.FeatureCategoryDepth.None || !this.props.stations) return null;
                  const largeArea = this.props.largeArea;
                  const city = this.props.city;
                  return (
                    <div className="site-sidebar">
                      <h2 className="site-sidebar__headline">{city.name_text}の駅で絞り込む</h2>
                      <div className="lpsearch-sidebar__focus clearfix">
                        <h3 className="lpsearch-sidebar__focus-category">{city.name_text}</h3>
                        <ul className="lpsearch-sidebar__focus-itemlist">
                        {this.props.stations.map((station)=>{
                          return (
                            <li key={station.id} className="lpsearch-sidebar__focus-item"><a href={`/features/${feature.uid}/cities/${city.name}--${largeArea.name}/stations/${station.id}`}>{station.name_text}</a></li>
                          );
                        })}
                        </ul>
                      </div>
                    </div>
                  );
                })()}
                <SMCategorySearchFilterView
                  keyword={this.props.keyword}
                  location={this.props.location}
                  geocode={this.props.geocode}
                  eventType={this.props.eventType}
                  capacity={this.props.capacity}
                  minCapacity={this.props.minCapacity}
                  maxCapacity={this.props.maxCapacity}
                  amenities={this.props.amenities}
                  minPrice={this.props.minPrice}
                  maxPrice={this.props.maxPrice}
                  spaceType={this.props.spaceType}
                  eventTypeList={this.props.eventTypeList}
                  capacityList={this.props.capacityList}
                  amenityList={this.props.amenityList}
                  spaceTypeList={this.props.spaceTypeList}
                />
                <SMFeatureStaffView staffFeatures={this.props.staffFeatures} />
                <SMFeatureRoomView roomFeatures={this.props.roomFeatures} />
              </div>
            </div>
          </div>
        </div>
        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>
    );
  }
}
export default SMFeatureView;



// WEBPACK FOOTER //
// ./app/javascript/components/features/SMFeatureView.jsx